import { BrokeragePlanning } from "../BrokeragePlanning";
import { DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningMultiProfile extends Layout {
    layoutBrokeragePlanning: BrokeragePlanning;
    sourceBrokerageMovements: DataSource;
    sourceBrokeragePlanningProfile: DataSource;
    tabProfile: Tab;
    tabsetBrokeragePlanningProfiles: Tabset;
}
